<template>
    <div class="CommentCarousel">
      <div id="SliderComment" class="carousel slide carousel-fade" data-bs-ride="carousel">
        <div class="carousel-indicators">
          <button type="button" aria-label="نظر مشتریان" data-bs-target="#SliderComment" :data-bs-slide-to="index" :class="index === 0 ? 'active' : ''" :key="(obj,index)" v-for="(obj,index) in objects" :aria-current="index === 0 ? 'true' : ''"></button>
        </div>
        <div class="carousel-inner">
          <div class="carousel-item p-4 pb-5" :class="index === 0 ? 'active' : ''" :key="(obj,index)" v-for="(obj,index) in objects">
            <a :href="obj.productLink">
              <img v-lazy="$MEDIA + obj.product.PNG" class="d-block center m-auto" :alt="obj.product.name">
              <h4 class="product-name mt-3">{{strLimit(obj.product.name, 55)}}</h4>
              <p>
                <span>
                  <span class="icon" :class="obj.rate >= 1 ? 'color-gold' : ''">★</span>
                  <span class="icon" :class="obj.rate >= 2 ? 'color-gold' : ''">★</span>
                  <span class="icon" :class="obj.rate >= 3 ? 'color-gold' : ''">★</span>
                  <span class="icon" :class="obj.rate >= 4 ? 'color-gold' : ''">★</span>
                  <span class="icon" :class="obj.rate >= 5 ? 'color-gold' : ''">★</span>
                </span>
              </p>
              <p class="text-comment">{{strLimit(obj.text , 100)}}</p>
              <p class="text-bold">{{obj.profile}}</p>
              <p>{{obj.date}}</p>
            </a>
          </div>
        </div>
        <button aria-label="قبلی" class="carousel-control-prev d-none d-md-block" type="button" data-bs-target="#SliderComment" data-bs-slide="prev">
          <i class="fa fa-arrow-left color-black" aria-hidden="true"></i>
        </button>
        <button aria-label="بعدی" class="carousel-control-next d-none d-md-block" type="button" data-bs-target="#SliderComment" data-bs-slide="next">
          <i class="fa fa-arrow-right color-black" aria-hidden="true"></i>
        </button>
      </div>
    </div>
</template>
<script>
export default {
  name: 'CommentCarousel',
  props: {
    objects: null
  }
}
</script>
<style scoped>
.carousel-item{
  text-align:center;
  background: #f3f3f3;
  border-radius: 24px;
}
img{
  width: 300px;
}
.carousel-indicators [data-bs-target]{
  background-color: #000;
}
.color-gold{
  color: gold;
}
.icon{
  font-size: 20pt;
}
.text-bold{
  font-weight: bold;
}
button{
  font-size: 10pt;
}
.product-name{
  min-height: 0px;
}
.text-comment{
  max-width: 800px;
  margin: auto;
  margin-bottom: auto;
  margin-bottom: 20px;
  min-height: 45px;
}
@media (max-width:768px)  {
  .product-name{
    min-height: 55px;
  }
  .text-comment{
    min-height: 50px;
  }
}
</style>
